
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/stock/meeting",
      function () {
        return require("private-next-pages/en/ir/stock/meeting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/stock/meeting"])
      });
    }
  